import { html } from '@/helpers/html-template'
import { EditorClasses } from '@/styles'
import type { AttributesEmbed } from './attributes'
import { getIframeAttributes } from './validate-src'
import { toVueComponent } from '@scalar-org/vue-render'
import { safeCompute } from '@/helpers/safe-compute'

export function guideEmbedHtml(props: AttributesEmbed) {
  const embedClasses = [EditorClasses.Embed, 'highlight-active']

  const iframeAttributes = safeCompute({
    method: () => getIframeAttributes(props.src),
    fallback: '',
  })

  return html`
<figure class="${embedClasses.join(' ')}" alt="${props.alt}">
  <iframe ${iframeAttributes} ></iframe>
  ${
    props.caption?.length
      ? html`<figcaption>${props.caption}</figcaption>`
      : html`<figcaption><ssg-children/></figcaption>`
  }
</figure>
  `
}

export const ScalarEmbedVue = toVueComponent<AttributesEmbed>(guideEmbedHtml, {
  src: String,
  caption: String,
  alt: String,
})
